import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App";
import StylesheetInjector from "./config/StylesheetInjector";

(async () => {
  StylesheetInjector();
  createRoot(document.getElementById("root")).render(<App />);
})();
